import ApiClient from '../api';

const lookupGeoCode = (zip) => {
    const urlPath = "/api/Location/LookupGeoCode?Query=" + zip;
    var response = ApiClient.get(urlPath);
    return response;
};

const LocationApi = { lookupGeoCode };
export default LocationApi;